<template>
  <a :href="tool.website" target="_blank">
    <div class="roundLogoContainer d-flex justify-content-center">
      <img
        v-if="tool.logo"
        :src="tool.logo"
        class="rounded-circle"
        :alt="tool.title"
      />
    </div>
    <!-- <p>{{ tool.title }}</p> -->
  </a>
</template>

<script>
export default {
  name: "StartScreenToolTemplate",
  props: {
    tool: Object,
  },
};
</script>

<style scoped>
a {
}
a:hover {
  text-decoration: none;
}
img {
  width: 65px;
  height: 65px;
  background: white;
  filter: none;
  -webkit-filter: blur(0px);
  -moz-filter: blur(0px);
  -ms-filter: blur(0px);
  filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius='0');
}
p {
  color: #9c9c9c;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
  text-align: center;
  overflow-wrap: break-word;
  margin-left: 5px;
  margin-right: 7px;
  margin-top: 10px;
}

@media only screen and (max-width:600px){
  img {
    width: 45px;
    height: 45px;
  }
}
</style>